/*
 * Application Insights JavaScript SDK - React Plugin, 19.3.7
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { __extendsFn as __extends } from "@microsoft/applicationinsights-shims";
import React from "react";
import { SeverityLevel } from "@microsoft/applicationinsights-common";
var AppInsightsErrorBoundary = /** @class */ (function (_super) {
    __extends(AppInsightsErrorBoundary, _super);
    function AppInsightsErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hasError: false };
        return _this;
    }
    AppInsightsErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ hasError: true });
        this.props.appInsights.trackException({
            error: error,
            exception: error,
            severityLevel: SeverityLevel.Error,
            properties: errorInfo
        });
    };
    AppInsightsErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            var onError = this.props.onError;
            return React.createElement(onError);
        }
        return this.props.children;
    };
    return AppInsightsErrorBoundary;
}(React.Component));
export default AppInsightsErrorBoundary;
//# sourceMappingURL=AppInsightsErrorBoundary.js.map